var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarkerBlueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "map-pin"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M35 16.668C35 28.3346 20 38.3346 20 38.3346C20 38.3346 5 28.3346 5 16.668C5 12.6897 6.58035 8.87441 9.3934 6.06137C12.2064 3.24832 16.0218 1.66797 20 1.66797C23.9782 1.66797 27.7936 3.24832 30.6066 6.06137C33.4196 8.87441 35 12.6897 35 16.668Z",
    fill: "#291482",
    stroke: "#291482",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20 21.668C22.7614 21.668 25 19.4294 25 16.668C25 13.9065 22.7614 11.668 20 11.668C17.2386 11.668 15 13.9065 15 16.668C15 19.4294 17.2386 21.668 20 21.668Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerBlueIcon);
export default __webpack_public_path__ + "static/media/marker-blue-icon.d77295b9716762459c1a398cfbbb2cd8.svg";
export { ForwardRef as ReactComponent };